import { Moon, Sun, Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { getThemePref, setThemePref, type ThemePref } from "@/lib/theme";

// Cycles Light → Dark → Follow System. The icon reflects the CURRENT choice.
const ORDER: ThemePref[] = ["light", "dark", "system"];
const LABEL: Record<ThemePref, string> = { light: "Light", dark: "Dark", system: "System" };

export function ThemeToggle() {
  const [pref, setPref] = useState<ThemePref>(() => getThemePref());

  // Stay in sync if another toggle (or boot) changes the preference.
  useEffect(() => {
    const onChange = () => setPref(getThemePref());
    window.addEventListener("dh-theme-change", onChange);
    return () => window.removeEventListener("dh-theme-change", onChange);
  }, []);

  const cycle = () => {
    const next = ORDER[(ORDER.indexOf(pref) + 1) % ORDER.length];
    setPref(next);
    setThemePref(next);
  };

  const Icon = pref === "light" ? Sun : pref === "dark" ? Moon : Monitor;

  return (
    <Button
      size="icon"
      variant="ghost"
      onClick={cycle}
      title={`Theme: ${LABEL[pref]} — tap to change`}
      aria-label={`Theme: ${LABEL[pref]}. Tap to switch (Light, Dark, or Follow System).`}
      data-testid="button-theme-toggle"
    >
      <Icon className="h-5 w-5" />
    </Button>
  );
}
